/**
 * Whether subjective questions are optional for the patient, on both the public patient-intake
 * questions step and the shared questionnaire (/notes/p/:note_id/questions).
 * Reads `patient_intake_subjective_optional` from `globals.tenant_info`
 * Defaults to false when the key is absent (subjective answers remain required).
 *
 * QA: omitted/undefined/`false`/`0`/`"0"` → required validation; `true`/`1`/`"1"` → optional (may submit empty).
 */
export const isPatientIntakeSubjectiveOptional = (globals) => {
	const ti = globals?.tenant_info;
	const raw = ti?.patient_intake_subjective_optional;
	if (raw === true || raw === 1 || raw === "1") return true;
	if (raw === false || raw === 0 || raw === "0") return false;
	return false;
};
